import React from "react";
import { observer } from "mobx-react";
import { useRootAppStore } from "@hooks";

import { SharedLoaderSpinner } from "@components/loader/shared";
export default observer(function ChatLoader() {
	const { chatViewStore } = useRootAppStore();

	if (!chatViewStore?.shouldRenderMainLoader) {
		return null;
	}

	return (
		<div className="loader chat__loader">
			<SharedLoaderSpinner />
		</div>
	);
});
